import { Stack, TableCell, TableRow, styled, Chip } from "@mui/material";
import { types } from "api";
import { green } from "@mui/material/colors";
import clsx from "clsx";
export interface RootTableRowProps {
	row: types.RegisteredUser;
}

const PREFIX = "RegisteredUserTableRow";

const classes = {
	root: `${PREFIX}-root`,
	admin: `${PREFIX}-admin`,
	adminTeacher: `${PREFIX}-adminTeacher`,
	teacher: `${PREFIX}-teacher`,
	student: `${PREFIX}-student`,
	parent: `${PREFIX}-parent`,
};

const CustomChip = styled("div")(({ theme }) => ({
	[`& .${classes.root}`]: {
		backgroundColor: "#d32f2f",
		color: theme.palette.background.paper,
		marginRight: theme.spacing(1),
	},
	[`& .${classes.admin}`]: {
		backgroundColor: theme.palette.secondary.main,
		color: theme.palette.background.paper,
		marginRight: theme.spacing(1),
	},
	[`& .${classes.adminTeacher}`]: {
		backgroundColor: "#5b3cc4",
		color: theme.palette.background.paper,
		marginRight: theme.spacing(1),
	},
	[`& .${classes.teacher}`]: {
		backgroundColor: theme.palette.secondary.light,
		color: theme.palette.background.paper,
		marginRight: theme.spacing(1),
	},
	[`& .${classes.student}`]: {
		backgroundColor: green[400],
		color: theme.palette.background.paper,
		marginRight: theme.spacing(1),
	},
	[`& .${classes.parent}`]: {
		backgroundColor: theme.palette.secondary.dark,
		color: theme.palette.background.paper,
		marginRight: theme.spacing(1),
	},
}));

export const RegisteredUserTableRow = ({
	row,
}: RootTableRowProps): JSX.Element => {
	return (
		<TableRow hover role="checkbox" key={row.userId}>
			<TableCell data-testid="firstName">
				<Stack direction="row" alignItems="center">
					{row.firstName}
				</Stack>
			</TableCell>
			<TableCell data-testid="lastName">{row.lastName}</TableCell>
			<TableCell data-testid="role">
				<CustomChip>
					{row.role.map((role, index) => (
						<Chip
							className={clsx({
								[classes.admin]: role === "admin",
								[classes.adminTeacher]: role === "admin-teacher",
								[classes.teacher]: role === "teacher",
								[classes.student]: role === "student",
								[classes.parent]: role === "parent",
							})}
							key={index}
							label={role}
						/>
					))}
				</CustomChip>
			</TableCell>
			<TableCell data-testid="email">{row.email}</TableCell>
			<TableCell data-testid="userId">{row.userId}</TableCell>
		</TableRow>
	);
};
